// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@keyframes animationRotate {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(1turn);
  }
}
/* Add Animation */
@keyframes animatetop {
  from {
    top: -300px;
    opacity: 0;
  }
  to {
    top: 0;
    opacity: 1;
  }
}
.__my_albums .__my_album_container {
  display: flex;
  gap: 20px;
  flex-wrap: wrap;
}
.__my_albums .__my_album_container .__add_albums {
  width: 210px;
}
@media (max-width: 576px) {
  .__my_albums .__my_album_container .__add_albums {
    width: 96px;
  }
}
.__my_albums .__my_album_container .__add_albums .__card__add {
  height: 210px;
  width: 210px;
}
@media (max-width: 576px) {
  .__my_albums .__my_album_container .__add_albums .__card__add {
    width: 96px;
    height: 96px;
    max-height: 152px;
  }
}
.__my_albums .__my_album_container .__album_row .__albums_card {
  width: 210px;
}
@media (max-width: 576px) {
  .__my_albums .__my_album_container .__album_row .__albums_card {
    width: 96px;
  }
}
.__my_albums .__my_album_container .__album_row .__albums_card ._album_image {
  width: 210px;
  height: 210px;
  object-fit: cover;
}
@media (max-width: 576px) {
  .__my_albums .__my_album_container .__album_row .__albums_card ._album_image {
    width: 96px;
    height: 96px;
    object-fit: cover;
  }
}`, "",{"version":3,"sources":["webpack://./src/styles/_mixins.scss","webpack://./src/pages/Albums/index.scss"],"names":[],"mappings":"AAGA;EACE;IACE,oBAAA;ECFF;EDIA;IACE,wBAAA;ECFF;AACF;ADKA,kBAAA;AAYA;EACE;IACE,WAAA;IACA,UAAA;ECJF;EDMA;IACE,MAAA;IACA,UAAA;ECJF;AACF;AA1BE;EACE,aAAA;EACA,SAAA;EACA,eAAA;AA4BJ;AA3BI;EACE,YAAA;AA6BN;ADCE;EC/BE;IAGI,WAAA;EA+BN;AACF;AA9BY;EACE,aAAA;EACA,YAAA;AAgCd;ADRE;EC1BU;IAKI,WAAA;IACA,YAAA;IAEA,iBAAA;EAgCd;AACF;AA5BM;EACE,YAAA;AA8BR;ADlBE;ECbI;IAGI,WAAA;EAgCR;AACF;AA/BQ;EACE,YAAA;EACA,aAAA;EACA,iBAAA;AAiCV;AD5BE;ECRM;IAKI,WAAA;IACA,YAAA;IACA,iBAAA;EAmCV;AACF","sourcesContent":["@import \"./colors.scss\";\n@import \"./breakpoints\";\n\n@keyframes animationRotate {\n  from {\n    transform: rotate(0);\n  }\n  to {\n    transform: rotate(1turn);\n  }\n}\n\n/* Add Animation */\n@-webkit-keyframes animatetop {\n  from {\n    top: -300px;\n    opacity: 0;\n  }\n  to {\n    top: 0;\n    opacity: 1;\n  }\n}\n\n@keyframes animatetop {\n  from {\n    top: -300px;\n    opacity: 0;\n  }\n  to {\n    top: 0;\n    opacity: 1;\n  }\n}\n\n// Small devices\n@mixin sm {\n  @media (max-width: #{$screen-sm-max}) {\n    @content;\n  }\n}\n\n@mixin upToSm {\n  @media (min-width: #{$screen-sm-min}) {\n    @content;\n  }\n}\n\n// Medium devices\n@mixin md {\n  @media (min-width: #{$screen-md-min}) {\n    @content;\n  }\n}\n\n// Large devices\n@mixin lg {\n  @media (min-width: #{$screen-lg-min}) {\n    @content;\n  }\n}\n\n// Extra large devices\n@mixin xl {\n  @media (min-width: #{$screen-xl-min}) {\n    @content;\n  }\n}\n\n// Custom devices\n@mixin rwd($screen) {\n  @media (min-width: #{$screen}px) {\n    @content;\n  }\n}\n\n@mixin screnRange($min, $max) {\n  @media (min-width: #{$min}px) and (max-width: #{$max}px) {\n    @content;\n  }\n}\n\n@mixin screenHeightRange($min, $max) {\n  @media (min-height: #{$min}px) and (max-height: #{$max}px) {\n    @content;\n  }\n}\n","@import \"./../../styles/mixins\";\n.__my_albums {\n  .__my_album_container {\n    display: flex;\n    gap: 20px;\n    flex-wrap: wrap;\n    .__add_albums {\n      width: 210px;\n      @include sm {\n        width: 96px;\n      }\n            .__card__add {\n              height: 210px;\n              width: 210px;\n      \n              @include sm {\n                width: 96px;\n                height: 96px;\n      \n                max-height: 152px;\n              }\n            }\n    }\n    .__album_row {\n      .__albums_card {\n        width: 210px;\n        @include sm {\n          width: 96px;\n        }\n        ._album_image {\n          width: 210px;\n          height: 210px;\n          object-fit: cover;\n          @include sm {\n            width: 96px;\n            height: 96px;\n            object-fit: cover;\n          }\n        }\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
